module.exports = __webpack_public_path__ + "static/img/giftbox.6ce67aff.png";